import { Button } from '@react-apps/design-system';

/**
 * Barra de ações em massa da tela de preview. Só existe enquanto há questão
 * selecionada, e fica `fixed` no canto esquerdo — o FAB de criar questão mora no
 * direito, então as duas não disputam espaço.
 */
export function BulkActionsBar({
  count,
  onDelete,
  onTransfer,
  onClear,
}: {
  count: number;
  onDelete: () => void;
  onTransfer: () => void;
  onClear: () => void;
}) {
  if (count === 0) return null;

  return (
    <div className="border-(--color-border) bg-(--color-bg-primary) fixed bottom-6 left-6 z-40 flex flex-wrap items-center gap-3 rounded-xl border p-3 shadow-lg">
      <span className="text-(--color-text-primary) text-sm font-medium">
        {count} {count === 1 ? 'selecionada' : 'selecionadas'}
      </span>
      <Button type="button" variant="secondary" onClick={onTransfer}>
        Transferir questões
      </Button>
      <Button type="button" variant="danger" onClick={onDelete}>
        Excluir selecionadas
      </Button>
      <Button type="button" variant="ghost" onClick={onClear}>
        Limpar
      </Button>
    </div>
  );
}
